// Announce the object on screen to the Orca bar (news preview, selected event,
// open position…). Higher priority wins: open sheet/preview 3, selected object 2,
// page-level object 1. Unregisters when the object goes away.
import { useEffect, useId } from 'react';
import type { AskCtx } from './contexts';
import { useOrca } from './OrcaProvider';

export function useAskContext(ctx: AskCtx | null, priority = 2) {
  const id = useId();
  const { registerCtx } = useOrca();
  // builders return fresh objects every render: re-register only when the object changes
  const key = ctx ? `${ctx.kind}|${ctx.label}|${ctx.question}` : '';
  useEffect(() => {
    registerCtx(id, ctx, priority);
    return () => registerCtx(id, null, priority);
  }, [key, priority]); // eslint-disable-line react-hooks/exhaustive-deps
}
